import { useEffect, useState } from "react";
import NormalSelect from "../../../component/NormalSelect";
import TableWrapper from "../../../component/TableWrapper";
import Exported from "../../../service/endpoints";
import request from "../../../service";
import { Toast } from "../../../service/toast";
import { Icons } from "../../../assets";
import classes from "./style.module.scss";
import ConfirmationModal from "../../../modalComponents/ConfirmationModal";

const UserRoleList = (props) => {
    const { searchInput } = props
    const [page, setPage] = useState(1);
    const [sortConfig, setSortConfig] = useState(null);
    const [userList, setUserList] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [showPopUp, setShowPopUp] = useState(false)
    const [selectedId, setSelectedId] = useState(null)

    const userHeader = [
        { label: "S.No" },
        { label: 'User Name', sortable: "name" },
        { label: 'Email', sortable: "email" },
        { label: 'Mobile Number' },
        { label: 'Role' },
        { label: 'Date Joined' },
        // { label: 'Status' },
        { label: 'Actions' },
    ];

    useEffect(() => {
        getUserList()
    }, [page, sortConfig, searchInput])


    const getUserList = async () => {
        setisLoading(true)
        let url = `${Exported.Endpoints.getUserRolesList}`
        let paramsObj = {
            page: page,
            limit: 10,
        }

        if (sortConfig) {
            paramsObj['sort'] = sortConfig?.key
            paramsObj['sortOrder'] = sortConfig?.direction
        }

        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }

        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta
                }
                setUserList(obj)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        setisLoading(false)
    }

    const handleChange = (id) => {
        setShowPopUp(true)
        setSelectedId(id)
    }

    const handleRoleChange = async () => {
        let url = `${Exported.Endpoints.userRoleChange}/${selectedId}`;
        const requestData = {}

        await request({
            url: url,
            method: Exported.APIMethods.PUT,
            data: requestData,
        })
            .then(async (res) => {
                if (res?.data && res?.data) {
                    await getUserList()
                    setShowPopUp(false)
                }
            })
            .catch((err) => {
                console.log(err, 'err');
                Toast({
                    type: 'error',
                    message: 'Unable to process the request!..',
                });
            });
    }


    const handleData = (keyValue, defaultValue, className = '') => {
        return (
            <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
        )
    };

    const handleClose = () => {
        setShowPopUp(false)
    }

    return (
        <>
            <div className={`eventWrapper`}>
                <div className={`mt-2 mb-5 ${classes.retailTableWrapper}`}>
                    <TableWrapper
                        headerDetails={userHeader}
                        pageMeta={userList?.pageMeta}
                        handlePageChange={setPage}
                        listLength={userList?.result || []}
                        isLoading={isLoading}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                    >
                        {userList?.result?.map((item, index) => {
                            const {
                                username = "",
                                email = "",
                                mobileNumber = "",
                                userRole = "",
                                id = "",
                                createdAt = "",
                                // approvedByAdmin,
                            } = item;
                            return (
                                <tr key={`${id}-${index}`}>
                                    {handleData(
                                        (page - 1) * 10 + (index + 1),
                                        "-",
                                        "text-center"
                                    )}
                                    {handleData(username, "-", "text-center")}
                                    {handleData(email, "-", "text-center")}
                                    {handleData(mobileNumber, "-", "text-center")}
                                    {handleData(userRole, "-", "text-center")}
                                    {handleData(
                                        createdAt
                                            ? new Date(createdAt).toLocaleDateString("en-GB")
                                            : "-",
                                        "-",
                                        "text-center"
                                    )}
                                    {/* {handleData(approvedByAdmin, "-", "text-center")} */}
                                    <td className=" px-3 mx-auto text-center action-button">
                                        <div className="flex items-center justify-center">
                                            <img
                                                src={Icons.changeIcon}
                                                alt="View"
                                                className="cursor-pointer w-[20px] h-[20px]"
                                                onClick={() => handleChange(id)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </TableWrapper>
                </div>
            </div>
            {showPopUp ? (
                <ConfirmationModal
                    isOpen={showPopUp}
                    handleSuccess={handleRoleChange}
                    closePopUp={handleClose}
                    warningText={"Confirmation"}
                    modalText={"Are you sure you want to change the role of the user?"}
                    confirmText={"Yes"}
                    cancelText={"No"}
                    primaryBtnConfirm={false}
                />
            ) : null}
        </>
    )
}

export default UserRoleList